import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { LiveEventsProvider } from "@/lib/liveEvents";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Radar from "@/pages/Radar";
import Groups from "@/pages/Groups";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Threads from "@/pages/Threads";
import Goals from "@/pages/Goals";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AppShell from "@/components/AppShell";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-[#05050A] text-white/60 font-mono text-xs">SYNCING SIGNAL…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/radar" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route element={<Protected><LiveEventsProvider><AppShell /></LiveEventsProvider></Protected>}>
        <Route path="/radar" element={<Radar />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/threads" element={<Threads />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}
